import { useContext } from "react";
import { useQuery, UseQueryResult } from "react-query";

import { startIvv } from "@/apis/IVVHelper";
import { getRetryDelayMs, shouldRetry } from "@/helpers/react-query-helper";
import { AppContext } from "@/stores/appStore";

/**
 * Custom hook to notify users about the completion of the Day 1 Wizard.
 */
export const useStartIvv = (): UseQueryResult<string> => {
  const { state } = useContext(AppContext);

  return useQuery("startIvv", startIvv, {
    enabled: state.amplifyConfigured,
    retry: (failureCount, err) => shouldRetry(failureCount, err),
    retryDelay: (retryCount) => getRetryDelayMs(retryCount),
  });
};
